/**
 * Per-browser preferences (not tenant settings) controlling whether archived
 * or deleted records show up by default across every list in the app — see
 * `MySettingsPage`, the one place a person can change them. Read once at a
 * list page's mount via a lazy `useState` initializer, the same pattern
 * `MySettingsPage` itself uses; there is no live cross-tab subscription, so a
 * change takes effect the next time a given list page mounts.
 */

const STORAGE_KEY_DELETED = 'tabita.preferences.showDeletedRecords';
const STORAGE_KEY_ARCHIVED = 'tabita.preferences.showArchivedRecords';

function readPreference(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    // Private browsing, or a browser blocking storage entirely — the
    // preference just doesn't persist; it must not crash the page.
    return false;
  }
}

function writePreference(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    // Same as above — persistence is best-effort.
  }
}

export function getShowArchivedRecordsPreference(): boolean {
  return readPreference(STORAGE_KEY_ARCHIVED);
}

export function setShowArchivedRecordsPreference(value: boolean): void {
  writePreference(STORAGE_KEY_ARCHIVED, value);
}

export function getShowDeletedRecordsPreference(): boolean {
  return readPreference(STORAGE_KEY_DELETED);
}

export function setShowDeletedRecordsPreference(value: boolean): void {
  writePreference(STORAGE_KEY_DELETED, value);
}
